/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * GetTimeSlots Input Action
 */

var apiKey: string = "";
var apiEndPoint: string = "";

export class GetTimeSlotsInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    constructor(args: Msdyn365.ICreateActionContext) {
        apiKey = args.requestContext.app.config.timeSlotAPIKey;
        apiEndPoint = args.requestContext.app.config.timeSlotAPIURL;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `TimeSlots`;
    public getCacheObjectType = () => 'TimeSlots';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetTimeSlotsData {
    timeslots: ITimeSlot[];
}

export interface ITimeSlot {
    ID: number;
    Timings: string;
    ColorCode: string;
    Enabled: boolean;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetTimeSlotsInput(args);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function GetSlotsAction(input:GetTimeSlotsInput, ctx: Msdyn365.IActionContext):Promise<IGetTimeSlotsData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // TODO: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IGetTimeSlotsData[]>('/get/example/id/1', 'get');
    const channelID = ctx.requestContext.channel?.ChannelNaturalId;


    var result = await Msdyn365.sendRequest<ITimeSlot[]>(`${apiEndPoint}?code=${apiKey}&RetailChannelId=${channelID}`,
    'get')
    .then((response: Msdyn365.IHTTPResponse<ITimeSlot[]>) => {
        return response.data;
    });

    return {timeslots: result};
}

export const IGetTimeSlotsAction =  Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetTimeSlotsData>>GetSlotsAction,
    input: createInput
});

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetTimeSlotsData>>GetSlotsAction,
    input: createInput
});